var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGlobeSlated02(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.66113 18.3388L7.25499 13.745M18.2175 2.78247C21.9275 6.49245 21.9275 12.5075 18.2175 16.2175C14.5075 19.9275 8.49243 19.9275 4.78245 16.2175M17 22H6.99997M12 22V19M17.5 9.49998C17.5 12.8137 14.8137 15.5 11.5 15.5C8.18626 15.5 5.49997 12.8137 5.49997 9.49998C5.49997 6.18628 8.18626 3.49998 11.5 3.49998C14.8137 3.49998 17.5 6.18628 17.5 9.49998Z",
    stroke: "#070707",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlobeSlated02);
export default __webpack_public_path__ + "static/media/globe-slated-02.a42d17e2c8aee3db3b6ae24c1a0f76cf.svg";
export { ForwardRef as ReactComponent };